import { kycSumsubConstants } from '../constant/kyc-sumsub.constant';

export const kycSumsubAction = {
    setIsLoading,
    setError,
    updateStep,
};

function setIsLoading(flag) {
    return (dispatch) => {
        dispatch({
            type: kycSumsubConstants.SET_IS_LOADING,
            payload: {
                isLoading: flag,
            },
        });
    };
}

function setError(error) {
    return (dispatch) => {
        dispatch({
            type: kycSumsubConstants.SET_ERROR,
            payload: {
                error: error,
            },
        });
    };
}

function updateStep({ index, updatedStepData }) {
    return (dispatch) => {
        dispatch({
            type: kycSumsubConstants.UPDATE_STEP,
            payload: {
                index,
                updatedStepData,
            },
        });
    };
}
